import { IMessageDataImage } from "@home-health-notify/domain";
import { getImageThumbUrl } from "hhn-commons";
import React from "react";
import DisplayImage from "../../../common/DisplayImage";
import { DisplayMediaProps } from "../../../common/DisplayMediaProps";
import { isBlobImage } from "../../../utils/MessageUtils";

const DisplayThumbImage = ({
  imageData,
  ...rest
}: {
  imageData: IMessageDataImage;
} & DisplayMediaProps) => {
  const thumbImageUrl = isBlobImage(imageData.url)
    ? imageData.url
    : getImageThumbUrl(imageData.url);
  return <DisplayImage url={thumbImageUrl} alt={imageData.text} {...rest} />;
};

export default DisplayThumbImage;
